<template>
  <div v-if="user" id="pageProfile" class="contact-page page-home desk-frame">
    <!-- Header -->
    <header-desktop :userUpdateRequestExists="user.updateRequestExists" />
    <menu-desktop />
    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <!-- Info -->
    <section class="profile-hello text center">
      <b class="bold">רופא/ה יקר/ה,</b>
      <br class="mobile_only" />
      פרופיל הרופא מוצג באתר האינטרנט של ביה"ח ומשמש את הגולשים לקבלת מידע
      אודותיך. ניתן לעדכן מידע חדש או לערוך מידע קיים ככל הנדרש.
    </section>

    <vue-loaders-ball-clip-rotate
      v-show="!user?.first_name"
      class="profile-loader"
      color="#2a2e80"
      scale="3"
    ></vue-loaders-ball-clip-rotate>

    <div v-show="user?.first_name" class="profile-container">
      <!-- Hero -->
      <section class="profile-hero bg--blue center tx--white">
        <div class="profile-image-wrap inline relative">
          <div class="profile-image relative">
            <img :src="user.image" />
            <div
              v-if="user.updateAvatarRequestExists"
              class="profile-image-overlay"
            >
              <img src="assets/img/svg/ok-white.svg" />
              בקשה לתיאום <br />צילום נשלחה
            </div>
          </div>
          <!--/profile-image-->
          <div
            class="ask-photo-mobile flex flex--column flex--content--center tx--under mobile_only"
            @click="openRequestPhotoPopup"
          >
            <img src="assets/img/svg/camera.svg" />
            בקשה לצילום חדש
          </div>
        </div>
        <!--/profile-image-wrap-->

        <div
          class="ask-photo flex flex--content--center tx--under no_mobile pointer"
          @click="openRequestPhotoPopup"
        >
          <img src="assets/img/svg/camera.svg" />
          תיאום צילום תמונה חדשה
        </div>
        <h1 class="title bold tx--white no-marge">
          {{ user.title }} {{ user.first_name }}
          {{ user.last_name }}
        </h1>
        <div class="text tx--white">{{ user.job }}</div>
        <div v-if="user.first_name">
          <router-link
            v-if="!user.updateRequestExists"
            to="profile-edit"
            class="profile-edit-bt mobile_only flex flex--content--center tx--under tx--white"
          >
            <img src="assets/img/svg/ic-pen-white.svg" />
            עריכת פרופיל
          </router-link>
          <div
            class="profile-edit-bt flex flex--content--center tx--white"
            v-else
          >
            <img src="assets/img/svg/ic-pen-white.svg" />

            בקשתך לעריכה בטיפול
          </div>
        </div>

        <!-- Page -->
      </section>

      <div class="inner-profile-container">
        <div class="inner_group bg--white no-marge profile-inner">
          <h2 class="title">קצת עלי</h2>
          <div class="text">
            {{ user.about }}
          </div>
          <div class="langs-profile">
            <h3>שפות:</h3>
            <div class="flex flex--start">
              <span v-for="lang in user.languages" :key="lang">
                {{ lang }}
              </span>
            </div>
          </div>
        </div>
        <!--/about-->

        <!-- Roles -->
        <div
          class="book_surgery desk_inner_width toggleContainer active no-marge"
        >
          <div class="book_surgery_top flex pointer" onclick="toggle(this)">
            <span class="title">תפקידים</span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </div>
          <div class="book_surgery_open toggleInner" style="display:block">
            <div class="inner_group bg--white no-marge">
              <div class="add_new_row" v-for="(role, i) in user.roles" :key="i">
                <div class="text">{{ role }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Clinical experience -->
        <div
          class="book_surgery desk_inner_width toggleContainer active no-marge"
        >
          <div class="book_surgery_top flex pointer" onclick="toggle(this)">
            <span class="title">ניסיון קליני</span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </div>
          <div class="book_surgery_open toggleInner" style="display:block">
            <div class="inner_group bg--white no-marge">
              <div
                class="add_new_row"
                v-for="(exp, i) in user.clinical_exp"
                :key="i"
              >
                <div class="text">
                  {{ exp }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Education -->
        <div
          class="book_surgery desk_inner_width toggleContainer active no-marge"
        >
          <div class="book_surgery_top flex pointer" onclick="toggle(this)">
            <span class="title">השכלה</span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </div>
          <div class="book_surgery_open toggleInner" style="display:block">
            <div class="inner_group bg--white no-marge">
              <div
                class="add_new_row"
                v-for="(edu, i) in user.education"
                :key="i"
              >
                <div class="text">
                  {{ edu }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Courses -->
        <div
          class="book_surgery desk_inner_width toggleContainer active no-marge"
        >
          <div class="book_surgery_top flex pointer" onclick="toggle(this)">
            <span class="title">השתלמויות</span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </div>
          <div class="book_surgery_open toggleInner" style="display:block">
            <div class="inner_group bg--white no-marge">
              <div
                class="add_new_row"
                v-for="(course, i) in user.courses"
                :key="i"
              >
                <div class="text">
                  {{ course }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Memberships -->
        <div
          class="book_surgery desk_inner_width toggleContainer active no-marge"
        >
          <div class="book_surgery_top flex pointer" onclick="toggle(this)">
            <span class="title">חברות באיגודים מקצועיים</span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </div>
          <div class="book_surgery_open toggleInner" style="display:block">
            <div class="inner_group bg--white no-marge">
              <div
                class="add_new_row"
                v-for="(ms, i) in user.memberships"
                :key="i"
              >
                <div class="text">
                  {{ ms }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--bottom-->
        <div class="inner-profile-bottom no_mobile">
          <router-link
            v-if="!user.updateRequestExists"
            to="profile-edit"
            class="bt_blue-rounded"
            style="width:220px;"
          >
            <img src="assets/img/svg/ic-pen-white.svg" />
            עריכת פרופיל
          </router-link>
        </div>
      </div>
      <!--/inner-profile-container-->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import HeaderDesktop from "@/components/Shared/HeaderDesktop.vue";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import Error from "@/components/Popups/Error";
import EditProfilePhotoRequest from "@/components/Popups/EditProfilePhotoRequest";
import { requestUpdateUserAvatar } from "../api/api-quatro";

export default {
  name: "Profile",
  components: { DashboardHeader, Menu, HeaderDesktop, MenuDesktop },
  data() {
    return {
      user: {
        title: "",
        first_name: "",
        last_name: "",
        image: "",
        about: "",
        job: "",
        roles: [],
        clinical_exp: [],
        education: [],
        courses: [],
        memberships: [],
        updateRequestExists: true,
        updateAvatarRequestExists: false,
        languages: []
      }
    };
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"])
  },
  methods: {
    ...mapMutations(["UPDATE_USER_PROFILE"]),
    ...mapActions(["GET_USER_PROFILE"]),
    openRequestPhotoPopup() {
      if (!this.user) return;
      this.$modal.show(EditProfilePhotoRequest, {
        isRequestExists: this.user.updateAvatarRequestExists,
        func: this.requestUpdateAvatar
      });
    },
    async requestUpdateAvatar() {
      if (this.user.updateAvatarRequestExists) return;

      try {
        const res = await requestUpdateUserAvatar(this.user.license);
        if (res["status"] !== "success") {
          this.$modal.show(Error, {
            title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
          });
          return;
        }

        this.user.updateAvatarRequestExists = true;
        this.UPDATE_USER_PROFILE({ updateAvatarRequestExists: true });
      } catch (error) {
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
        console.log(error);
      }
    }
  },
  async created() {
    window.scrollTo(0, 0);
    this.user = await this.GET_USER_PROFILE();
  }
};
</script>
